/* istanbul ignore file */
import React from 'react';

import {assertIsNotNullish} from '@br/idm-components';

import {LogIn} from '../../components/LogIn';
import type {FormErrors, Message, OIDCLoginConfiguration} from '../../types';
import {safeLoadJson} from '../../utils/data';

const loginSettings = safeLoadJson<OIDCLoginConfiguration>('#oidc_logins');
const errors = safeLoadJson<FormErrors>('#form_errors') || {};
const messages = safeLoadJson<Message[]>('#messages') || [];
const initialUsername = safeLoadJson<string>('#username') || '';

assertIsNotNullish(loginSettings);

const Login = () => (
    <LogIn
        loginConfiguration={loginSettings}
        errors={errors}
        messages={messages}
        initialUsername={initialUsername}
    />
);

export default Login;
